import { AxiosInstance, AxiosRequestConfig } from "axios";

export const sagAuthInterceptor = (config: AxiosRequestConfig) => {
    config.headers ??= {};
    config.headers["Ocp-Apim-Subscription-Key"] = environment.settings["Integrations:SAG:PublicSubscriptionKey"];

    return config;
};

export const addSagAuthInterceptor = (httpClient: AxiosInstance) => {
    // TODO: remove ts ignore when https://github.com/axios/axios/issues/3733 is fixed
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    httpClient.interceptors.request.use(sagAuthInterceptor, null, { synchronous: true });
};
